import { render, staticRenderFns } from "./StampHistoryCard.vue?vue&type=template&id=f5b717a6&scoped=true"
import script from "./StampHistoryCard.vue?vue&type=script&lang=js"
export * from "./StampHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./StampHistoryCard.vue?vue&type=style&index=0&id=f5b717a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b717a6",
  null
  
)

export default component.exports